import { Injectable } from '@angular/core';
import { IAddressSearcherData } from '@df/ui/form/address-searcher';
import { AddressSearcherService } from '@df/ui/form/address-searcher.service';
import { PcaAddressSearcher } from './pca-address-searcher';

@Injectable()
export class PcaAddressSearcherService extends AddressSearcherService {
    create(addressSearcherData: IAddressSearcherData) {
        return new PcaAddressSearcher(addressSearcherData, this.options);
    }
}
